import { InventorySortByDialog } from './inventory-sort-by-dialog';
import { DIALOG, transitions } from 'dialogs';
import { MarketplaceDialogs } from '../../../marketplace-dialogs.config';

DIALOG.add(MarketplaceDialogs.INVENTORY_SORT_BY_FILTERS, {
  component: InventorySortByDialog,
  transition: transitions.SLIDE_UP,
  anchor: 'inventory-portal',
});
